exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trainer-info[data-v-0ae4b6de]{position:relative;margin-left:5px}.trainer-info__info[data-v-0ae4b6de]{list-style:none;margin:0;padding:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;text-align:left}.trainer-info__info li[data-v-0ae4b6de],.trainer-info__info span[data-v-0ae4b6de]{font-size:12px}.trainer-info__info li span[data-v-0ae4b6de]:first-child{color:#0080da}", ""]);

// exports
